/**
 * LakePalaceDestination — destination-wedding plot-plane experience.
 *
 * Registered under id 'lake-palace-destination' so PublicInvitation.tsx and
 * DraftPreview.tsx route here via registry.has(templateId).
 *
 * The id is immutable and MUST stay in lockstep with:
 *   - InviteCloudBackend/prisma/migrations/20261015000000_add_lake_palace_destination_template
 *   - invitecloudFrontend/src/modules/pages/wizard/StepTemplate.tsx (LAKE_PALACE_DESTINATION_TEMPLATE)
 */

import React from 'react';
import { LakePalaceDestinationExperience } from '@/src/modules/experiences/wedding/lake-palace/LakePalaceDestinationExperience';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';

const META: TemplateMetadata = {
  id: 'lake-palace-destination',
  name: 'Lake Palace Destination',
  occasionType: 'WEDDING',
  description:
    'A destination-wedding journey across a misty lake: scroll from the boat arrival to the marble jetty, the palace courtyard, the function arcade over water, and an RSVP terrace with map and travel notes.',
  isPremium: true,
  tags: ['wedding', 'destination', 'udaipur', 'lake-palace', 'plot-plane', 'cinematic', 'marble', 'premium'],
  colorScheme: {
    primary: '#123b58',
    accent: '#d9b26a',
    bg: '#08202f',
  },
};

export function LakePalaceDestination({ data }: { data: InvitationData }) {
  return <LakePalaceDestinationExperience data={data} />;
}

registry.register({ metadata: META, component: LakePalaceDestination });
